import { Component, Inject, Input, forwardRef } from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { GroupModel }         from './typings/group-rights.group';
import { GroupRightsService } from './group-rights.service';
import { MessagesService }    from '../messages/messages.service';

@Component({
  selector   : 'wor-group-rights-groups',
  template: require('./group-rights.groups.component.html')
})
export class GroupRightsGroupsComponent {
  @Input() groups: Array<GroupModel>;

  isAddingNew = false;

  group: GroupModel = {
    group_name: ''
  };

  selectedGroup: GroupModel = {
    group_name: ''
  };

  constructor (
    @Inject(forwardRef(() => GroupRightsService)) private groupsService   : GroupRightsService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  addNew () : void {
    this.isAddingNew = true;
  }

  cancelAddition () : void {
    this.isAddingNew = false;
  }

  handleGroupSelection () : void {
    this.router.stateService.go('app.group-rights', {
      group_name: this.selectedGroup.group_name
    });
  }

  save ( form : NgForm ) : void {
    this.groupsService.create(this.group)
    .then(( group : GroupModel ) => {
      this.router.stateService.go('app.group-rights', {
        group_name: group.group_name
      });

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.GROUP'), 'success');
    })
    .catch(error => this.messagesService.error(error));
  }
}
